// Imports
import React from "react"
import { BrandLogo } from "@icons"
import { useFooterData } from "@queries"

export const Footer = () => {
  const { sectionMiddle, sectionCompany, sectionLegal } = useFooterData()
  return (
    <footer>
      <div className="footer-container">
        <div>
          <BrandLogo />
        </div>
        <div className="footer-rows">
          {sectionMiddle.map((row, i) => {
            return (
              <div className="footer-rows-row" key={i}>
                <h5>{row.name}</h5>
                <div className="footer-rows-row__links">
                  {row.links.map((link, i) => {
                    return (
                      <div className="footer-rows-row__link" key={i}>
                        <a href={link.link}>{link.name}</a>
                        {i !== row.links.length - 1 && (
                          <span className="footer-rows-row__link-bulletpoint"></span>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="footer-bottom__company">
            <h5> {sectionCompany.name} </h5>
            <div className="footer-bottom__company-contacts">
              {sectionCompany.links.map((link, i) => {
                return (
                  <React.Fragment key={i}>
                    <a href={`${link.type}:${link.link}`}>{link.text}</a>
                    {i !== sectionCompany.links.length - 1 && <span></span>}
                  </React.Fragment>
                )
              })}
            </div>
          </div>
          <div className="footer-bottom__legal">
            {sectionLegal.links.map((link, i) => {
              return (
                <React.Fragment key={i}>
                  <a href={link.link}>{link.text}</a>
                  {i !== sectionLegal.links.length - 1 && (
                    <span className="footer-bottom__legal-bulletpoint"></span>
                  )}
                </React.Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </footer>
  )
}
